module.exports = __webpack_public_path__ + "img/hotel-12.1ee79169.jpeg";